import type { ConfigState } from "../state/config/config.reducer";
import type { MyWorkspaceMetadata } from "../state/workspaces/types";
import { getWorkspaceURL } from "./url.helpers";

export function openWorkspaceInNewWindow(
  myWorkspaceMetadata: MyWorkspaceMetadata,
  config: ConfigState,
) {
  window.open(
    getWorkspaceURL(
      myWorkspaceMetadata.workspaceType,
      myWorkspaceMetadata.workspaceId,
      config,
      myWorkspaceMetadata.module?.name ?? "",
    ),
    myWorkspaceMetadata.workspaceId,
  );
}
